import { gql } from '@apollo/client';

export const GET_DSP_DELIVERY_COMPLETED_SUMMARY_PAGE_LIST = gql`
  query GetDspDeliveryCompletedSummaryPageList($pageRequest: DspDeliveryCompletedSummaryPageRequestTypeInput!) {
    getDspDeliveryCompletedSummaryPageList(pageRequest: $pageRequest) {
      pageResponse {
        content {
          deliveredDate
          hubId
          hubName
          warehouseId
          warehouseName
          areaId
          areaName
          dspId
          dspName
          dspFullName
          dspContact
          driverId
          driverName
          driverPhone
          deliveredCount
          standardRateDeliveredCount
          discountRateDeliveredCount
        }
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

export const GET_DSP_DELIVERY_COMPLETED_SUMMARY_BY_DRIVER_GROUP_PAGE_LIST = gql`
  query GetDspDeliveryCompletedSummaryByDriverGroupPageList(
    $pageRequest: DspDeliveryCompletedSummaryByDriverGroupPageRequestTypeInput!
  ) {
    getDspDeliveryCompletedSummaryByDriverGroupPageList(pageRequest: $pageRequest) {
      pageResponse {
        content {
          driverId
          driverName
          driverPhone
          totalDeliveredCount
          totalStandardRateDeliveredCount
          totalDiscountRateDeliveredCount
          items {
            deliveredDate
            hubId
            hubName
            warehouseId
            warehouseName
            areaId
            areaName
            dspId
            dspName
            dspFullName
            dspContact
            driverId
            driverName
            driverPhone
            deliveredCount
            standardRateDeliveredCount
            discountRateDeliveredCount
          }
        }
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

export interface DspDeliveryCompletedSummaryType {
  deliveredDate: string;
  hubId: number;
  hubName: string;
  warehouseId: number;
  warehouseName: string;
  areaId: number;
  areaName?: string | null;
  dspId: number;
  dspName?: string | null;
  dspFullName: string;
  dspContact?: string | null;
  driverId?: number | null;
  driverName: string;
  driverPhone: string;
  deliveredCount: number;
  standardRateDeliveredCount: number;
  discountRateDeliveredCount: number;
}

export interface DspDeliveryCompletedSummaryFilterType {
  deliveredDateStart: string;
  deliveredDateEnd: string;
}

export interface DspDeliveryCompletedSummaryPageRequestType {
  filter: DspDeliveryCompletedSummaryFilterType;
  pageRequest: {
    page: number;
    size: number;
    sortBy?: string | null;
    sortDirection?: string | null;
  };
}

export interface DspDeliveryCompletedSummaryPageResponseData {
  content: DspDeliveryCompletedSummaryType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface DspDeliveryCompletedSummaryPageResponseType {
  pageResponse: DspDeliveryCompletedSummaryPageResponseData;
}

export interface GetDspDeliveryCompletedSummaryPageListResponse {
  getDspDeliveryCompletedSummaryPageList: DspDeliveryCompletedSummaryPageResponseType;
}

export interface DspDeliveryCompletedSummaryByDriverGroupType {
  driverId: number;
  driverName?: string | null;
  driverPhone?: string | null;
  totalDeliveredCount: number;
  totalStandardRateDeliveredCount: number;
  totalDiscountRateDeliveredCount: number;
  items: DspDeliveryCompletedSummaryType[];
}

export interface DspDeliveryCompletedSummaryByDriverGroupFilterType {
  deliveredDateStart: string;
  deliveredDateEnd: string;
}

export interface DspDeliveryCompletedSummaryByDriverGroupPageRequestType {
  filter: DspDeliveryCompletedSummaryByDriverGroupFilterType;
  pageRequest: {
    page: number;
    size: number;
  };
}

export interface DspDeliveryCompletedSummaryByDriverGroupPageResponseData {
  content: DspDeliveryCompletedSummaryByDriverGroupType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface DspDeliveryCompletedSummaryByDriverGroupPageResponseType {
  pageResponse: DspDeliveryCompletedSummaryByDriverGroupPageResponseData;
}

export interface GetDspDeliveryCompletedSummaryByDriverGroupPageListResponse {
  getDspDeliveryCompletedSummaryByDriverGroupPageList: DspDeliveryCompletedSummaryByDriverGroupPageResponseType;
}

